import { BrowserVersionConfig } from '../utilities/browserVersionCheck';

/**
 * Browser version configuration
 * Define minimum supported versions for each browser
 * If a browser is not listed or version is undefined, all versions are considered supported
 */
export const minutVersionConfig: BrowserVersionConfig = {
  chrome: 109,
  firefox: 111,
  safari: 26,
  edge: 109,
  opera: 76
};
// Versionerna �r h�r definerade av FileSystemWritableFileStream